// ./src/pages/Terms/index.js
import React from 'react';

const Terms = () => (
  <div className="max-w-3xl mx-auto px-6 py-12">
    <h1 className="text-3xl font-bold text-gray-900 mb-8">Terms of Service</h1>
    <div className="prose prose-lg">
      <p className="text-gray-600 mb-6">
        Last updated: December 28, 2025
      </p>
      
      <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">1. Acceptance of Terms</h2>
      <p className="text-gray-600 mb-6">
        By accessing or using DeltaOps.app, you agree to be bound by these Terms of Service and all applicable laws and regulations.
      </p>

      <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">2. Use License</h2>
      <p className="text-gray-600 mb-6">
        <strong>Permission Granted:</strong> Subject to your compliance with these Terms, DeltaOps grants you a limited, non-exclusive, non-transferable license to use our services.<br/>
        <strong>Restrictions:</strong> You agree not to:
        <ul className="list-disc list-inside mt-2">
          <li>Modify, copy, distribute, or create derivative works from the service.</li>
          <li>Reverse engineer or attempt to extract the source code.</li>
          <li>Use the service for any unlawful or prohibited activities.</li>
        </ul>
      </p>

      <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">3. User Responsibilities</h2>
      <p className="text-gray-600 mb-6">
        You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.
      </p>

      <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">4. Intellectual Property</h2>
      <p className="text-gray-600 mb-6">
        All content, trademarks, service marks, and logos displayed on DeltaOps.app are the property of DeltaOps or their respective owners. Unauthorized use is prohibited.
      </p>

      <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">5. Termination</h2>
      <p className="text-gray-600 mb-6">
        DeltaOps reserves the right to terminate or suspend your access to the service at our sole discretion, without notice, for conduct that DeltaOps believes violates these Terms or is harmful to other users.
      </p>

      <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">6. Disclaimers</h2>
      <p className="text-gray-600 mb-6">
        The service is provided "as is" and "as available" without warranties of any kind. DeltaOps does not warrant that the service will be uninterrupted or error-free.
      </p>

      <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">7. Limitation of Liability</h2>
      <p className="text-gray-600 mb-6">
        In no event shall DeltaOps be liable for any indirect, incidental, special, consequential, or punitive damages arising out of your use of the service.
      </p>

      <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">8. Indemnification</h2>
      <p className="text-gray-600 mb-6">
        You agree to indemnify, defend, and hold harmless DeltaOps and its affiliates from any claims, damages, obligations, losses, liabilities, costs, or debt arising from your use of the service or violation of these Terms.
      </p>

      <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">9. Governing Law</h2>
      <p className="text-gray-600 mb-6">
        These Terms shall be governed by and construed in accordance with the laws of [Your Jurisdiction], without regard to its conflict of law principles.
      </p>

      <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">10. Dispute Resolution</h2>
      <p className="text-gray-600 mb-6">
        Any disputes arising out of or related to these Terms shall be resolved through binding arbitration in [Your Jurisdiction], unless otherwise required by law.
      </p>

      <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">11. Changes to Terms</h2>
      <p className="text-gray-600 mb-6">
        DeltaOps may modify these Terms at any time. We will notify you of significant changes by posting the new Terms on this page. Continued use of the service constitutes acceptance of the updated Terms.
      </p>

      <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">12. Contact Us</h2>
      <p className="text-gray-600">
        If you have any questions about these Terms, please contact us at <a href="mailto:marcus@DeltaOps.app" className="text-blue-600 underline">marcus@DeltaOps.app</a>.
      </p>
    </div>
  </div>
);

export default Terms;
